module.exports = __webpack_public_path__ + "img/002-settings.cfc8bed5.png";